import cn from "classnames"

import { Descriptions } from "@/atoms"
import * as issueDomain from "@/domain/issue/issue"
import { CodeResolveContent } from "@/molecules/FindingStatusTag/components/CodeResolveContent"

import styles from "../IssueTag.module.scss"

import type { TFunction } from "@/hooks/useTranslation"
import type { ContentPropsIssueStatusTag, RecordIssueStatusTag } from ".."

const getTagItems = (t: TFunction, record: RecordIssueStatusTag) => {
  const { discoveredAtInUserLocale, resolvedAtInUserLocale, resolutionData } =
    record
  const { timeToResolution = 30 } = resolutionData || {}

  return [
    { label: t("issue.discoveredAt"), children: discoveredAtInUserLocale },
    { label: t("issue.resolved.resolvedAt"), children: resolvedAtInUserLocale },
    {
      label: t("issue.timeToResolution"),
      children: `${timeToResolution} ${t("general.day", { count: timeToResolution })}`
    }
  ]
}

const getAlertItems = (t: TFunction, record: RecordIssueStatusTag) => {
  return getTagItems(t, record)
}

export const getMetaElement = (
  item: ReturnType<typeof getAlertItems>[number],
  index: number
) => (
  <span
    key={index}
  >{`${item.label}${item.children ? `: ${item.children}` : ""}`}</span>
)

export const ResolvedContent = (props: ContentPropsIssueStatusTag) => {
  const { component, record, t } = props

  if (component === "alert") return getAlertItems(t, record).map(getMetaElement)

  if (issueDomain.isResolvedInCodeRepoAndNotResolved(record))
    return (
      <CodeResolveContent
        resolutionData={
          record.resolutionData?.resolvedInCodeRepoCommit || {
            resolvedAt: 0,
            resolvedBy: null,
            commitHash: null
          }
        }
        t={t}
      />
    )

  return (
    <Descriptions
      grid
      classes={{ grid: cn("grid-description-component-ks", styles.label) }}
      items={getTagItems(t, record).map((item) => ({
        label: <Descriptions.Label>{item.label}</Descriptions.Label>,
        children: item.children
      }))}
    />
  )
}
